import { computed, createApp } from 'vue';
import App from './App.vue';
import router from '@/router';
import { cloneDeep } from 'lodash-es';
import { createPinia } from 'pinia';

import TDesign from 'tdesign-vue-next';
import { defaultGlobalConfig, configProviderInjectKey, mergeWith } from 'tdesign-vue-next/es/config-provider/context';
import { useTDesignConfig } from '@/config/tdesign';

import '@tencent/aix-design/dist/style.css'; // aix-design 样式
import 'tdesign-vue-next/es/style/index.css'; // tdesign 样式
import '@/assets/css/index.css'; // 项目样式
import './styles/theme.scss'; // 主题样式

// 给window对象挂载version信息
window.VITE_MI_BUILD_ID = import.meta.env.VITE_MI_BUILD_ID;

const app = createApp(App);
const pinia = createPinia();

const globalConfig = useTDesignConfig();
const defaultData = cloneDeep(defaultGlobalConfig);
const mergedGlobalConfig = computed(() => mergeWith(defaultData as any, globalConfig as any));

app.use(router).use(pinia).use(TDesign);

app.provide(configProviderInjectKey, mergedGlobalConfig);
app.mount('#app');
